<template>
    <v-snackbar
        v-model="notification.show"
        :timeout="notification.timeout"
        :bottom="true"
        :right="true"
        :color="notification.type"
    >
        <v-icon v-if="notification.type === 'error'" color="white" class="mr-2">
            mdi-alert-circle-outline
        </v-icon>
        <v-icon v-if="notification.type === 'info'" color="white" class="mr-2">
            mdi-information-outline
        </v-icon>

        <span>{{ notification.message }}</span>

        <template #action>
            <v-btn
                v-if="notification.action"
                outlined
                color="white"
                class="ml-2"
                :data-sentry-label="notification.action.label"
                @click.native="notificationAction(notification.action.data)"
            >
                {{ notification.action.label }}
            </v-btn>
            <v-btn
                v-else
                text
                icon
                color="white"
                data-sentry-label="Ukrywanie powiadomienia"
                @click.native="hideNotification"
            >
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </template>
    </v-snackbar>
</template>

<script>
export default {
    name: 'Snackbar',
    computed: {
        notification() {
            return this.$store.state.common.notification
        }
    },
    methods: {
        hideNotification() {
            return this.$store.dispatch('hideNotification')
        },
        notificationAction(action) {
            action === 'reload' ? window.location.reload(true) : window.location.href = action
        }
    }
}
</script>